<div class="with-2-levels box-content">
  <ul class="second-to-last-level">
    @for (thirdLevel of node?.children; track thirdLevel) {
      @if (thirdLevel?.children?.length || thirdLevel.url) {
        <li>
          <nav-label [node]="thirdLevel" classContainer="label"></nav-label>
        </li>
      }
    }
  </ul>
</div>
